import type { SVGProps } from "react";
import * as React from "react";

const SvgFiltersLines = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M6 11a1 1 0 1 0 0 2zm12 2a1 1 0 1 0 0-2zM3 5a1 1 0 0 0 0 2zm18 2a1 1 0 1 0 0-2zM9 17a1 1 0 1 0 0 2zm6 2a1 1 0 1 0 0-2zm-9-6h12v-2H6zM3 7h18V5H3zm6 12h6v-2H9z"
    />
  </svg>
);
export default SvgFiltersLines;
